/* template */
<template><div class="select-main"><div class="notice" v-if="(limit)"><es-icon name="exclamation-circle" size="12"/>{{notice}}</div><mpx-view @tap="handleClick('station')" class="select-item"><div class="select-item-title">到达站</div><div :class="({'select-item-value':true,disabled:(limit || isCross)})">{{toStation}}</div><es-icon color="#dddddd" name="angle-right" size="20" class="select-item-icon"/></mpx-view><mpx-view @tap="handleClick('date')" class="select-item"><div class="select-item-title">出发日期</div><div class="select-item-value">{{ticketDate.t}}<div class="week">{{ticketDate.w}}</div></div><es-icon color="#dddddd" name="angle-right" size="20" class="select-item-icon"/></mpx-view><es-button :disabled="(!toStation)" @click="handleClick('toTicket')" :custom-class='["submit-button active"].join(" ")'>查看可改签车次</es-button></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mfebbfea2"}'>
	$current-main-color = #FF7C46

	.select-main
		box-sizing border-box
		border-radius: 16px;
		background: #FFFFFF;
		box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.04);
		padding 12px 16px 20px
		margin 10px 0
		.notice
			height 32px
			display flex
			box-sizing border-box
			align-items center
			padding 9px 12px
			background rgba(255, 244, 238, 0.5)
			border-radius 8px
			color $current-main-color
			font-family PingFangSC-Regular
			font-size 12px
			font-weight normal
			line-height 14px
			letter-spacing 0px
			>>> .es-icon
				margin-right 4px
		.select-item
			height 52px
			border-bottom 1px solid #eee
			display flex
			align-items center
			color #666666
			font-family: PingFangSC-Regular;
			font-size: 12px;
			font-weight: normal;
			line-height: 19px;
			letter-spacing: 0px;
			&-title
				width 76px
				flex none
			&-value
				flex 1
				font-family PingFangSC-Medium
				font-size 18px
				font-weight normal
				line-height 24px
				letter-spacing 0px
				color #333333
				display flex
				align-items flex-end
				&.disabled
					color #999
				.week
					font-family PingFangSC-Regular
					font-size 13px
					line-height 19px
					margin-left 7px
			&-icon
				flex none
				width 20px
				height 20px
				display flex
				align-items center
				justify-content center
		.submit-button
			font-size 16px
			font-weight 600
			text-align center
			color white
			border-width 0px
			border-radius 8px
			margin-top 16px
			&.active
				background-color $current-main-color
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "mfebbfea2"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./select-station.mpx.js?isComponent&outputPath=components%2Fselect-stationfebbfea2%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./select-station.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fselect-stationfebbfea2%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["mfebbfea2"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/select-stationfebbfea2/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-button':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/button/index.mpx?isComponent&outputPath=components%2Findexbc68cb48%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
